import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Button, Form } from 'antd';
import React from 'react';

import IExecutionComponent from '../interfaces/IExecutionComponent';

const FormItem = Form.Item;

export interface IConfirmExecutionProps extends IExecutionComponent {
  form: any;
  description: string;
  yesLabel: string;
  noLabel: string;
  isRequired?: boolean;
}

interface IConfirmExecutionState {
  value?: boolean;
}

export default class ConfirmExecution extends React.Component<IConfirmExecutionProps, IConfirmExecutionState> {
  constructor(props: IConfirmExecutionProps) {
    super(props);

    this.state = {
      value: undefined,
    }

    this.onNoPressed = this.onNoPressed.bind(this);
    this.onYesPressed = this.onYesPressed.bind(this);
  }

  componentDidMount() {
    this.loadDefaultValues();
  }

  loadDefaultValues() {
    const { defaultValue } = this.props;
    if (defaultValue != undefined && defaultValue != null) {
      if (defaultValue) {
        this.onYesPressed();
      } else {
        this.onNoPressed();
      }
    }
  }

  onNoPressed() {
    this.setState({ value: false });
    this.props.onChange({
      id: this.props.id,
      value: false,
      validation: true,
    });
  }

  onYesPressed() {
    this.setState({ value: true });
    this.props.onChange({
      id: this.props.id,
      value: true,
      validation: true,
    });
  }

  getNoButtonStyle() {
    const { value } = this.state;
    if (value == undefined || value == true)
      return 'button-style unselected-btn';

    return 'button-style selected-btn';
  }
  getYesButtonStyle() {
    const { value } = this.state;
    if (value == undefined || value == false)
      return 'button-style unselected-btn';

    return 'button-style selected-btn';
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Wrapper>
        <Form>
          <FormItem>
            {getFieldDecorator('select-multiple', {
              rules: [
                { required: this.props.isRequired ? true : false, message: I18n.l("common.fieldRequired"), type: 'array' },
              ],
            })(
              <React.Fragment>
                <p>{this.props.description}</p>
                <Button onClick={this.onNoPressed} className={this.getNoButtonStyle()} >{this.props.noLabel}</Button>
                <Button onClick={this.onYesPressed} className={this.getYesButtonStyle()} >{this.props.yesLabel}</Button>
              </React.Fragment>
            )}
          </FormItem>
        </Form>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  .button-style{
    margin-right: 20px;
    font-weight: bold;
    text-transform: uppercase;
    color: ${Theme.primary.regular};
    min-width: 120px;
  }

  .unselected-btn {
    border-color: ${Theme.primary.regular};
  }
  .selected-btn {
    background-color: ${Theme.primary.regular};
    color: white;
  }
`


export const ConfirmExecutionComponent = Form.create()(ConfirmExecution);